module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-MdIt.3aa7fa1.ttf";